import styles from './CornerBanner.module.scss'

export default function Banner(props: {text: string, backgroundColor:string, color: string})
{
    return  <div className = {styles.cornerRibbon} style={{color: props.color, backgroundColor:props.backgroundColor}}>{props.text}</div>
}